import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipping-label-settings',
  templateUrl: './shipping-label-settings.component.html',
  styleUrls: ['./shipping-label-settings.component.css']
})
export class ShippingLabelSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
